import { render, staticRenderFns } from "./UserSpecialRequestsListItem.vue?vue&type=template&id=5ac6de9a&"
import script from "./UserSpecialRequestsListItem.vue?vue&type=script&lang=ts&"
export * from "./UserSpecialRequestsListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports